export const snackbarMessages = {
  save: {
    pending: '保存中です…',
    success: '保存しました',
    error: '保存中にエラーが発生しました'
  },
  inference: {
    pending: '推論実行中です…',
    success: '保存しました',
    error: '推論実行中にエラーが発生しました'
  },
  delete: {
    pending: '',
    success: '削除しました',
    error: '削除実行中にエラーが発生しました'
  }
};
